<template>
  <div>
    <div class="main-body--content margin-bottom-1rem">
      <c-block-box
        title="月预估营收(万元)"
        style="height: 11.75rem"
        class="margin-right-1rem top-item1"
        :icon="true"
      >
        <div class="total-revenue">
          <div class="left">
            <div class="revenue-box">
              <div class="number">{{ numberSplitWithComma(dig.monthForecast || 0) }}</div>
              <div class="tendency">
                <div class="tendency-text">
                  <span>环比</span>
                  <img :src="upsAndDowns(dig.weekRatio || 0)" />
                  <em>{{ percentage(dig.weekRatio || 0) }}%</em>
                </div>
              </div>
              <div class="target">
                <c-target-rate
                  label="目标"
                  :target="`${dig.monthTarget}万元`"
                  :is-progress="false"
                ></c-target-rate>
                <c-target-rate
                  label="当前营收"
                  :target="`${numberSplitWithComma(dig.monthIncome || 0)}万元`"
                  :is-progress="false"
                ></c-target-rate>
                <c-target-rate
                  label="匹配度"
                  :num="percentage(dig.monthMatchRatio || 0)"
                ></c-target-rate>
              </div>
            </div>
          </div>
        </div>
      </c-block-box>
      <c-block-box
        title="月总体营收（万元）"
        class="margin-right-1rem top-item"
        style="height: 11.75rem"
      >
        <div class="total-revenue">
          <div class="left" style="width: 7rem">
            <div class="revenue-box">
              <div class="number">{{ numberSplitWithComma(dig.monthIncome || 0) }}</div>
              <div class="tendency">
                <div class="tendency-text">
                  <span>环比</span>
                  <img :src="upsAndDowns(dig.monthRatio || 0)" />
                  <em>{{ percentage(dig.monthRatio || 0) }}%</em>
                </div>
              </div>
              <div class="target">
                <c-target-rate
                  label="目标"
                  :target="`${dig.monthTarget}万元`"
                  :is-progress="false"
                ></c-target-rate>
                <c-target-rate
                  label="完成率"
                  :num="percentage(dig.monthFinishRatio || 0)"
                ></c-target-rate>
                <c-target-rate
                  label="匹配度"
                  :num="percentage(dig.targetFinishRatio || 0)"
                ></c-target-rate>
              </div>
            </div>
          </div>
          <div class="right">
            <ChartBarLine
              id="revenue-line"
              width="100%"
              height="9.25rem"
              :option="revenueLine"
              v-if="businessLine.xData.length"
            ></ChartBarLine>
          </div>
        </div>
      </c-block-box>
      <c-block-box
        title="完单率"
        class="margin-right-1rem top-item"
        style="height: 11.75rem"
      >
        <div class="total-revenue">
          <div class="left" style="width: 10.5rem">
            <div class="revenue-box">
              <div class="number">{{ percentage(dig.projectRateCPM.projectRate || 0) }}%</div>
              <div class="tendency">
                <div class="tendency-text">
                  <span>环比</span>
                  <img :src="upsAndDowns(dig.projectRateCPM.projectMonthRate || 0)" />
                  <em>{{ percentage(dig.projectRateCPM.projectMonthRate || 0) }}%</em>
                </div>
              </div>
              <div class="target">
                <c-target-rate
                  :label="`目标 ${percentage(dig.projectRateCPM.projectRateTarget || 0)}% 完成率`"
                  :num="percentage(dig.projectRateCPM.projectRateTargetFinishRate || 0)"
                ></c-target-rate>
                <c-target-rate
                  label="执行项目数"
                  :target="(dig.pfinishNum || 0).toString()"
                  :is-progress="false"
                ></c-target-rate>
                <c-target-rate
                  label="缺量项目数"
                  :target="(dig.pundoneNum || 0).toString()"
                  :is-progress="false"
                ></c-target-rate>
              </div>
            </div>
          </div>
          <div class="right">
            <ChartBarLine
              id="business-line"
              width="100%"
              height="9.25rem"
              :option="businessLine"
              v-if="businessLine.xData.length"
            ></ChartBarLine>
          </div>
        </div>
      </c-block-box>
      <c-block-box
        title="月广告均价"
        style="height: 11.75rem"
        class="top-item"
      >
        <div class="total-revenue">
          <div class="left">
            <div class="revenue-box">
              <div class="number-name">开机</div>
              <div class="number">{{ numberSplitWithComma(dig.todayOpenPrice || 0) }}</div>
              <div class="number-name" style="padding-top: .8rem">前贴</div>
              <div class="number">{{ numberSplitWithComma(dig.todayPrePrice || 0) }}</div>
            </div>
          </div>
          <div class="right">
            <ChartBarLine
              id="business-line1"
              width="100%"
              height="9.25rem"
              :option="businessLine2"
              v-if="businessLine2.xData.length"
            ></ChartBarLine>
          </div>
        </div>
      </c-block-box>
    </div>
    <div class="digital-box2">
      <div class="left">
        <c-block-box
          title="闭环率"
          class="margin-bottom-1rem unit-box--custom unit-header--padding-1rem"
          :icon="true"
        >
          <div
            slot="sub-title"
            id="closePic"
            class="digital-btn coocaa_btn"
            leftTarget="#closePic"
            upTarget="#DigitalMarketing"
            router="/closed-loop-rate?type=closePic"
            rel="digitalDetails"
            @click="seeDetails('/closed-loop-rate?type=closePic')"
          >
            详情
          </div>
          <div class="table-body" style="height: 101px">
            <table
              class="table-item"
              width="100%"
              border="0"
              cellspacing="0"
              cellpadding="0"
            >
              <thead class="table-head">
                <tr>
                  <th class="head-item">流量分类</th>
                  <th class="head-item">目标</th>
                  <th class="head-item">上月完成项目数</th>
                  <th class="head-item">闭环项目数</th>
                  <th class="head-item">闭环完成数</th>
                  <th class="head-item">闭环率</th>
                </tr>
              </thead>
              <tbody class="table-body">
                <div class="vacancy"></div>
                <tr class="table-line" v-for="(item, index) in dig.closeRateData" :key="index">
                  <td class="body-lable">{{ item.dictLabel }}</td>
                  <td class="body-lable">{{ item.indicatorValueA }} %</td>
                  <td class="body-lable">{{ item.indicatorValueB }}</td>
                  <td class="body-lable">{{ item.indicatorValueC }}</td>
                  <td class="body-lable">{{ item.indicatorValueD }}</td>
                  <td class="body-lable">{{ item.indicatorValueE }} %</td>
                </tr>
              </tbody>
            </table>
          </div>
        </c-block-box>
        <c-block-box
          title="转推率"
          class="margin-bottom-1rem unit-header--padding-1rem"
          :icon="true"
        >
          <div class="table-body" style="height: 77px">
            <table
              class="table-item"
              width="100%"
              border="0"
              cellspacing="0"
              cellpadding="0"
            >
              <thead class="table-head">
                <tr>
                  <th class="head-item">总客户数</th>
                  <th class="head-item">转推流量</th>
                  <th class="head-item">目标</th>
                  <th class="head-item">转推数（转推中）</th>
                  <th class="head-item">转推率</th>
                </tr>
              </thead>
              <tbody class="table-body">
                <div class="vacancy"></div>
                <template v-for="(item, index) in dig.retweetRateData">
                  <tr class="table-line" :key="index" v-if="!index">
                    <td
                      :class="`body-lable ${index ? '' : 'border-none'}`"
                      rowspan="3"
                    >
                      {{ item.indicatorValueA }}
                    </td>
                  </tr>
                  <tr class="table-line" :key="index" v-else>
                    <td class="body-lable">{{ item.dictLabel }}</td>
                    <th class="body-lable">{{ item.indicatorValueA }}</th>
                    <td class="body-lable">{{ item.indicatorValueB }}</td>
                    <td class="body-lable">{{ item.indicatorValueC }} %</td>
                  </tr>
                </template>
              </tbody>
            </table>
          </div>
        </c-block-box>
        <div style="display: flex;" class="margin-bottom-1rem">
          <c-block-box
            style="flex: 1"
            title="直客&amp;代理销售占比"
            class="unit-header--padding-1rem margin-right-1rem"
          >
            <div style="height: 7.2rem;width: 70%;margin: 0 auto;">
              <ChartPie
                id="account-receivable-ratio"
                height="7.2rem"
                width="100%"
                :option="directAgent"
              ></ChartPie>
            </div>
          </c-block-box>
          <c-block-box
            style="flex: 1"
            title="直客销售占比"
            class="unit-header--padding-1rem"
          >
            <div
              slot="sub-title"
              class="digital-btn coocaa_btn"
              id="directPic"
              leftTarget="#directPic"
              upTarget="#closePic"
              router="'/closed-loop-rate?type=directPic"
              rel="digitalDetails"
              @click="seeDetails('/closed-loop-rate?type=directPic')"
            >
              详情
            </div>
            <div style="height: 7.2rem;width: 70%;margin: 0 auto;">
              <ChartPie
                id="account-receivable-ratio1"
                height="7.2rem"
                width="100%"
                :option="direct"
              ></ChartPie>
            </div>
          </c-block-box>
        </div>
        <c-block-box
          title="销售效能情况"
          class="unit-header--padding-1rem"
        >
          <div
            slot="sub-title"
            class="digital-btn coocaa_btn"
            id="recordPic"
            leftTarget="#recordPic"
            upTarget="#directPic"
            router="/closed-loop-rate?type=recordPic"
            rel="digitalDetails"
            @click="seeDetails('/closed-loop-rate?type=recordPic')"
          >
            详情
          </div>
          <div>
            <div class="efficiency-condition--body">
              <div class="efficiency-condition--left">
                <span>日跟进记录</span>
                <br />
                <em>{{ dig.dayRecord.recordNum || 0 }}条</em>
              </div>
              <div class="trapezoid">
                <div class="trapezoid-box" v-if="dig.monthRecord">
                  <div class="box-flex">
                    <div class="value">{{ dig.monthRecord.totalRecord || 0 }}条</div>
                    <div class="name">跟进记录<span>跑到</span></div>
                  </div>
                  <div class="box-flex">
                    <div class="value">{{ dig.monthRecord.totalBop || 0 }}个</div>
                    <div class="name">商机录入<span>跑透</span></div>
                  </div>
                  <div class="box-flex">
                    <div class="value">{{ dig.monthRecord.expect || 0 }}单</div>
                    <div class="name"><c-manual-icon style="padding:0 .25rem; margin:0 .25rem 0 0;"></c-manual-icon>预计开单<span>跑赢</span></div>
                  </div>
                </div>
                <div class="box one"></div>
                <div class="box two"></div>
                <div class="box three"></div>
              </div>
            </div>
          </div>
        </c-block-box>
      </div>
      <div class="right">
        <c-block-box
          title="近3月项目支撑情况"
          class="unit-header--padding-1rem"
        >
          <div class="business-tags" slot="sub-title">
            <span>启动阶段</span>
            <span class="span1">实施阶段</span>
            <span class="span2">收尾阶段</span>
          </div>
          <div style="height: 33.5rem">
            <project-list :project="projectLIst"></project-list>
          </div>
        </c-block-box>
      </div>
    </div>
  </div>
</template>

<script>
import common from '@/mixins/common.js'
import ChartBarLine from '@/components/echarts/line1'
import ChartPie from '@/components/echarts/pie'
import ProjectList from '../components/ProjectList'

export default {
  mixins: [common],
  components: {
    ChartBarLine,
    ChartPie,
    ProjectList
  },
  props: {},
  data () {
    return {
      directAgent: {
        config: {
          type: 2,
          picRadius: '80%',
          picCenter: ['30%', '50%'],
          tooltip: {
            show: true
          },
          legend: {
            right: 20,
            y: 'center'
          }
        },
        data: []
      },
      direct: {
        config: {
          type: 2,
          picRadius: '80%',
          picCenter: ['30%', '50%'],
          tooltip: {
            show: true
          },
          legend: {
            right: 20,
            y: 'center'
          }
        },
        data: []
      },
      projectLIst: [],
      dig: {
        monthRecord: {},
        dayRecord: {},
        projectRateCPM: {}
      },
      timeData: {
        data: {
          up: {},
          cur: {},
          down: {}
        }
      },
      revenueLine: {
        grid: {
          left: 10,
          right: 20,
          bottom: 10,
          top: 40,
          containLabel: true
        },
        boundaryGap: false,
        xData: [],
        series: []
      },
      businessLine: {
        grid: {
          left: 10,
          right: 20,
          bottom: 10,
          top: 40,
          containLabel: true
        },
        boundaryGap: false,
        color: ['#FF5A18', '#FFD71A', '#1895FF', '#1EE4DC'],
        xData: [],
        series: []
      },
      businessLine2: {
        grid: {
          left: 10,
          right: 20,
          bottom: 10,
          top: 40,
          containLabel: true
        },
        boundaryGap: false,
        xData: [],
        series: []
      }
    }
  },
  computed: {
    isAndroid () {
      return this.$store.state.app.isAndroid
    }
  },
  methods: {
    lineFormatData (data, type) {
      const isAndroid = this.isAndroid
      const keys = Object.keys(data)
      let minValueArr = []
      keys.forEach((item) => {
        minValueArr.push(this.mathMin(data[item].data || []))
      })
      const minValue = this.mathMin(minValueArr)
      const lineData = {
        min: minValue,
        xData: data[keys[0]].date.map(item => {
          return this.$cUtils.format.formatDate(item, 'MM-dd')
        }),
        series: keys.map(item => {
          const itemData = {
            name: item,
            data: data[item].data,
            symbol: 'none',
            type: 'line',
            lineStyle: {
              type: item === '目标' ? 'dashed' : 'solid',
              width: isAndroid ? 0.5 : 2
            }
          }
          if (type && item !== '目标') {
            this.$set(itemData, 'areaStyle', {})
            this.$set(itemData, 'stack', '总量')
          }
          return itemData
        })
      }
      return lineData
    }
  },
  created () {},
  activated () {
    const yearMonth = JSON.parse(sessionStorage.getItem('toggleDate')).time
    this.$service.fetch({
      url: 'api/digitalMarketing/dashboard?month=' + yearMonth
    }).then(res => {
      this.dig = res
      const isAndroid = this.isAndroid
      this.projectLIst = res.projects
      this.revenueLine = Object.assign(this.revenueLine, this.lineFormatData(res.dayIncome, 1), {
        legend: {
          top: !isAndroid ? 10 : 20
        }
      })
      this.businessLine = Object.assign(this.businessLine, this.lineFormatData(res.projectRateCPM.projectPic), {
        legend: {
          top: !isAndroid ? 10 : 20
        }
      })
      this.businessLine2 = Object.assign(this.businessLine2, this.lineFormatData(res.price), {
        legend: {
          top: !isAndroid ? 10 : 20
        }
      })
      const directAgent = res.directAgent ?? {}
      this.directAgent.data = Object.keys(directAgent).map(item => {
        return {
          name: item,
          value: directAgent[item]
        }
      })
      const direct = res.direct ?? {}
      this.direct.data = Object.keys(direct).map(item => {
        return {
          name: item,
          value: direct[item]
        }
      })
      this.$nextTick(() => {
        this.$parent.bindKey(this.$route.name)
      })
    })
  }
}
</script>

<style lang="stylus" scoped>
@import '../stylus/DigitalMarketing.styl'
</style>
